import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import Seo from "../components/Seo";
import GoogleAuthButton from "../components/GoogleAuthButton";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    const r = await register(email, password, name);
    setBusy(false);
    if (r.ok) {
      toast.success("Account created");
      nav("/dashboard");
    } else setError(r.error);
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid lg:grid-cols-2" data-testid="register-page">
      <Seo title="Create your account — BizzAtlas" description="Sign up free and get listed on BizzAtlas in under a minute." />
      <div className="hidden lg:flex flex-col justify-between surface-navy p-12 relative overflow-hidden">
        <div className="absolute inset-0 bg-grain opacity-30" />
        <div className="relative">
          <div className="font-display text-3xl">BizzAtlas</div>
          <p className="mt-3 text-zinc-400 text-sm font-mono-tag uppercase tracking-[0.18em]">/ Global B2B Directory</p>
        </div>
        <div className="relative space-y-3">
          <div className="font-display text-4xl leading-tight">Join 19 industries of vetted providers.</div>
          <ul className="text-sm text-zinc-400 space-y-1">
            <li>· Free forever listing</li>
            <li>· Verified badge on Pro & Premium</li>
            <li>· Ad credits to boost discovery</li>
          </ul>
        </div>
        <div className="relative font-mono-tag text-[10px] text-zinc-500 uppercase">v1 · register</div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5">
          <div>
            <h1 className="font-display text-3xl tracking-tight">Create your account.</h1>
            <p className="text-sm text-zinc-500 mt-1">Takes 30 seconds. No credit card.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="name">Full name</Label>
            <Input id="name" required value={name} onChange={(e) => setName(e.target.value)} data-testid="reg-name-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="reg-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reg-password-input" />
          </div>
          {error && <div className="text-sm text-red-600" data-testid="reg-error">{error}</div>}
          <Button type="submit" className="w-full btn-brand" disabled={busy} data-testid="reg-submit-btn">
            {busy ? "Creating…" : "Create account"}
          </Button>
          <div className="flex items-center gap-3 text-xs text-zinc-400 uppercase tracking-widest font-mono-tag">
            <div className="flex-1 h-px bg-zinc-200" />
            or
            <div className="flex-1 h-px bg-zinc-200" />
          </div>
          <GoogleAuthButton label="Sign up with Google" />
          <div className="text-sm text-zinc-500">Already have an account? <Link to="/login" className="text-zinc-900 underline">Sign in</Link></div>
        </form>
      </div>
    </div>
  );
}
